import React, { useState, useRef, useEffect } from 'react';
import { LogOut } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

function UserMenu({ userName = 'John Doe', avatarUrl = '/favicon.ico' }) {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const menuRef = useRef();

  const toggleMenu = () => setOpen(!open);

  // Close dropdown if clicking outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('token');
    // Cached sidebar branding belongs to this login, not the next one
    localStorage.removeItem('companyBranding');
    navigate('/login');
  };

  return (
    <div className="relative" ref={menuRef}>
      <button
        onClick={toggleMenu}
        className="flex items-center space-x-1 focus:outline-none focus:ring-2 focus:ring-blue-200 rounded"
      >
        <img src={avatarUrl} alt="User Avatar" className="w-9 h-9 rounded-full object-cover" />
        <span className="text-white font-semibold hidden sm:inline">{userName}</span>
      </button>

      {open && (
        <div className="absolute right-0 mt-2 w-40 bg-white rounded shadow-lg z-20">
          <button
            onClick={handleLogout}
            className="w-full flex items-center gap-2 px-4 py-2 text-red-600 hover:bg-red-50 rounded"
          >
            <LogOut size={16} />
            Logout
          </button>
        </div>
      )}
    </div>
  );
}

export default UserMenu;
